export default class MailingTemplate {

  constructor(modelData, store) {

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
    this.store = store
  }

  getDefault() {
    return {
      id: null,
      accountCount: null,
      eventId: null,
      icon: null,
      isDefault: false,
      isVisible: false,
      json: null,
      mailingTypeId: null,
      position: 0,
      translations: {
        de: {
          name: null,
          description: null
        },
        en: {
          name: null,
          description: null
        }
      }
    }
  }

  set(data) {
    Object.assign(this, data)
  }

  getJSON() {
    return {
      id: this.id,
      accountCount: this.accountCount,
      eventId: this.eventId,
      icon: this.icon,
      isDefault: this.isDefault,
      isVisible: this.isVisible,
      json: this.json,
      mailingTypeId: this.mailingTypeId,
      position: this.position,
      translations: this.translations
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mailingTemplate/model.js